
import { useState, useCallback } from 'react';
import { useAttendanceStore } from '../../store/attendanceStore';
import { format, isToday } from 'date-fns';

export const useAttendanceData = () => {
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());
  const { getDailyAttendance } = useAttendanceStore();
  
  const getTeachersWithAttendance = useCallback((timetableData: any[]) => {
    if (!timetableData || !Array.isArray(timetableData)) return [];
    
    const dateStr = format(selectedDate, 'yyyy-MM-dd');
    const dailyAttendance = getDailyAttendance(dateStr);
    
    return timetableData.map(teacher => {
      const attendance = dailyAttendance.find(a => a.teacherId === teacher.id);
      
      let classesToday = 0;
      if (teacher.classes && Array.isArray(teacher.classes)) {
        classesToday = teacher.classes.filter(c => {
          try {
            const classDate = new Date(c.startTime);
            return format(classDate, 'yyyy-MM-dd') === dateStr;
          } catch (e) {
            return false;
          }
        }).length;
      }
      
      return {
        id: teacher.id,
        name: teacher.name,
        avatar: teacher.avatar,
        attendanceStatus: attendance?.status || 'absent',
        checkInTime: attendance?.checkInTime,
        reason: attendance?.reason,
        hasSubstitute: attendance?.hasSubstitute || false,
        substituteName: attendance?.substituteName,
        classesToday
      };
    });
  }, [getDailyAttendance, selectedDate]);

  return {
    selectedDate,
    setSelectedDate,
    getTeachersWithAttendance
  };
};
